export const UserMultiple = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M29.0048 30V25C29.0048 21.6863 26.3137 19 23 19V19" stroke="currentColor" stroke-width="2"/>
<path d="M20.0049 15.0273C23.3337 15.0273 26.0322 12.3288 26.0322 9C26.0322 5.67119 23.3337 2.97266 20.0049 2.97266" stroke="currentColor" stroke-width="2"/>
<circle cx="12.0645" cy="9" r="6" stroke="currentColor" stroke-width="2"/>
<path d="M3.06445 30V25C3.06445 21.6863 5.75074 19 9.06445 19H15.0645C18.3782 19 21.0645 21.6863 21.0645 25V30" stroke="currentColor" stroke-width="2"/>
</svg>`;
